import {terrainDebugRefresh} from "../../Terrain/Heights/TerrainDebug.js";
import {sceneryDebugRefresh} from "../../Terrain/Scenery/Render/SceneryDebug.js";
import {vrDebug} from "../../UI/Tools/VR/LHQ/VRDebug.js";
import {wrr} from "webpack-runtime-require";

/** You can use these tools in the live page (through window.diag) to inspect the threejs scenes, terrain system, etc. */
export const diag = {
	/** eg. `diag.vrDebug.summary()`, `.meshes("Balcony")`, `.mesh("BalconyFloorTiled")`, `.suspects()` */
	vrDebug,
	terrainDebug: terrainDebugRefresh(),
	terrainDebug3D: terrainDebugRefresh(),
	sceneryDebug: sceneryDebugRefresh(),

	// getters for accessing the exports of arbitrary modules at runtime
	// ==========
	
	/** module.name_long [ie. module path but with "/" -> "_", and ending with "__"] -> module.exports
	 * Example: The exports of "Source/Utils/Diagnostics/Diagnostics.ts" ends up stored under key "Source_Utils_Diagnostics_Diagnostics__". */
	get moduleExports() {
		wrr.ParseModuleData();
		return wrr.moduleExports;
	},
	/** module.name_short -> module.exports */
	get moduleExports_byShortName() {
		wrr.ParseModuleData();
		return wrr.moduleExports_byShortName;
	},
	/** The result of combining module.exports of every module into one collection. [key clashes have "_" appended] */
	get moduleExports_flat() {
		wrr.ParseModuleData();
		return wrr.moduleExports_flat;
	},
};
globalThis.diag = diag;